import styled from 'styled-components';
import Button from '../Button';
import { IAuxiliaryButtonProps } from '../../../../types';

const AuxiliaryButtonWrapper = styled(Button)<IAuxiliaryButtonProps>`
  background-color: ${({ bgColor, theme }) =>
    bgColor ? `var(--base-color-${bgColor})` : theme.colors.auxiliaryButton};
  height: 20px;
  border: none;
  padding: 0;
  font-family: var(--font-family-buttons);
  font-size: var(--button-font-size);
  font-weight: var(--button-font-weight);
  color: var(--base-color-${({ color }) => color});
  width: fit-content;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  box-sizing: border-box;

  .auxiliaryButtonIcon {
    width: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export default AuxiliaryButtonWrapper;
